import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

/**
 * Drives the global Integrate / Submit form modal.
 *
 * The provider exposes `openForm({ type })` and `closeForm()`.
 * `type` is one of: "token" | "dapp" | "integration" | "collab" | "general".
 * Any component in the tree can call `useIntegrateModal().openForm(...)`.
 */
const IntegrateModalContext = createContext({
  isOpen: false,
  type: null,
  openForm: () => {},
  closeForm: () => {},
});

export function IntegrateModalProvider({ children }) {
  const [state, setState] = useState({ isOpen: false, type: null });

  const openForm = useCallback((opts = {}) => {
    setState({ isOpen: true, type: opts.type || "general" });
  }, []);

  const closeForm = useCallback(() => {
    setState((prev) => ({ ...prev, isOpen: false }));
  }, []);

  const value = useMemo(
    () => ({ isOpen: state.isOpen, type: state.type, openForm, closeForm }),
    [state.isOpen, state.type, openForm, closeForm]
  );

  return (
    <IntegrateModalContext.Provider value={value}>
      {children}
    </IntegrateModalContext.Provider>
  );
}

export function useIntegrateModal() {
  return useContext(IntegrateModalContext);
}
